<style>
</style>
<template>
  <div class="card">
    <header class="card-header bg-primary text-white d-flex align-items-center font-weight-bold"> Master Sertifikasi Reguler 
    <div class="ml-auto mr2">
        <a href="#/sertifikasi-new/master-sertifikasi/tambah" class="">
            <button type="button" class="btn btn-md btn-success ml-auto mr-2">Tambah</button>
        </a>
         <a href="#/sertifikasi-new/master-sertifikasi/tambah-rpl" class="">
            <button type="button" class="btn btn-md btn-success ml-auto mr-2">Tambah RPL</button>
        </a>
    </div>
    </header>
    <div class="card-body">
        <div class="row">
            <div class="col-sm-12 col-xl-12">
                <label for="exampleFormControlSelect1">Pilih Level</label>
                <multiselect
                  class="mulit-select"
                  label="namaLevel"
                  placeholder="Pilih Level"
                  :show-labels="false"
                  @select="pilihLevel"
                  v-model="level"
                  required
                  id="selectLevel"
                  :options="optionMasterLevel"
                ></multiselect>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-4 col-xl-4">
                <label for="exampleFormControlSelect1">Data Perhalaman</label>
                <select class="form-control" id="exampleFormControlSelect1" @change="pageDisplay">
                  <option value="all">Semua</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="100">100</option>
                </select>
            </div>
            <div class="col">
            </div>
            <div class="col-sm-4 col-xl-4">
                <label for="exampleFormControlSelect1">Pencarian</label>
                <input type="text" v-model="search" class="form-control" placeholder="Kode / Nama Sertifikasi">
            </div>
        </div>
        <br>
        <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kodeSertifikasi="{item}">
              <td
                class="py-2 font-weight-bold"
              >{{ item.kodeSertifikasi ? item.kodeSertifikasi : '-' }}</td>
            </template>
            <template #namaSertifikasi="{item}">
              <td class="py-2">{{ item.namaSertifikasi ? item.namaSertifikasi : '-' }}</td>
            </template>
            <template #statusSubModul="{item}">
              <td class="py-2">{{ item.statusSubModul ? item.statusSubModul : '-' }}</td>
            </template>
            <template #workshopStatus="{item}">
              <td class="py-2">{{ item.workshopStatus ? item.workshopStatus : '-' }}</td>
            </template>
            <template #level="{item}">
              <td class="py-2">{{ item.level ? item.level : '-' }}</td>
            </template>
            <template #biayaPendaftaran="{item}">
              <td class="py-2">Rp. {{ formatPrice(item.biayaPendaftaran) ? formatPrice(item.biayaPendaftaran) : '-' }}</td>
            </template>
            <template #jumlahMataUji="{item}">
              <td class="py-2">{{ item.jumlahMataUji ? item.jumlahMataUji : '-' }}</td>
            </template>
            <template #statusSertifikasi="{item}">
                <td class="py-2 text-center">
                    <font-awesome-icon icon="check" class="text-success" v-if="item.statusSertifikasi == 'Active'" />
                    <font-awesome-icon icon="times" class="text-danger" v-else />
                </td>
            </template>
            <template #aksi="{item, index}">
                <td class="py-2 text-center d-flex align-items-center">
                  <router-link
                  v-if="item.tipeSertifikasi == '1'"
                  :to="'/sertifikasi-new/master-sertifikasi/'+item.kodeSertifikasi+'/edit'"
                  class="btn btn-sm btn-info mr-1 px-2"
                  square
                  v-c-tooltip="'Ubah'"
                  >
                    <font-awesome-icon icon="edit" />
                  </router-link>
                  <router-link
                  v-else
                  :to="'/sertifikasi-new/master-sertifikasi/'+item.kodeSertifikasi+'/rpl-edit'"
                  class="btn btn-sm btn-info mr-1 px-2"
                  square
                  v-c-tooltip="'Ubah'"
                  >
                    <font-awesome-icon icon="edit" />
                  </router-link>
                  <CButton v-c-tooltip="'Hapus'" color="danger" class="btn btn-sm btn-info mr-1 px-2" square @click="deleteData(item, index)">
                      <font-awesome-icon icon="trash" />
                  </CButton>
                </td>
            </template>
            
        </CDataTable>
    </div>
</div>
</template>
<script>
import { AlertUtils } from "@/mixins/AlertUtils";
import { Level } from "@/mixins/master/Level";
import { exportUtils } from "@/mixins/exportUtils";

import SertifikasiService from "@/services/sertifikasi/master-sertifikasi.service.new";

const fields = [
  { key: "no" },
  {
    key: "kodeSertifikasi",
    label: "Kode",
    _style: 'width: 7rem'
  },
  {
    key: "namaSertifikasi",
    label: "Nama Sertifikasi"
  },
  {
    key: "statusSubmodul",
    label: "Submodul"
  },
  {
    key: "workshopStatus",
    label: "Workshop"
  },
  {
    key: "level",
    label: "Level"
  },
  {
    key: "biayaPendaftaran",
    label: "Biaya Pendaftaran",
    _style: "width: 15%"
  },
 
  {
    key: "jumlahMataUji",
    label: "Jumlah Mata Uji"
  },
  {
    key: "statusSertifikasi",
    label: "Status",
    _style: "text-align: center"
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center"
  }
];
export default {
    name: "MasterSertifikasi",
    mixins: [AlertUtils, Level, exportUtils],
    data() {
        return {
            actionPost: "",
            fields,
            idLevelAnggota : '',
            multi_kategori: '',
            details: [],      
            status: false,
            myModal: false,
            horizontal: { label: "col-3", input: "col-9" },
            collapseDuration: 0,
            content: [],
            loading: true,

            level: '',
            items: [],
            currentPage: 0,
            pageSize: 10,
            search: "",
            pagination: {
                totalPages: 0
            },
            indexed: 0,

            received_messages: [],
            send_message: null,
            connected: false,
            totalNotif: 0,
            item : [],
            stompClient : null,
            socket : null,
            role_status : null,
            tipe_halaman:"all_data",
            timeOutSearch : null
        };
    },
    mounted() {
        this.roleData();
        this.getAllLevel();
        setTimeout(() => {      
          this.getData(this.currentPage, this.pageSize, this.search, this.level.idLevelAnggota);
        }, 1000)  
    },
    watch: {
      search: function(value) {
        clearTimeout(this.timeOutSearch)
        this.timeOutSearch = setTimeout(() => {      
            this.getData(this.currentPage - 1, 10, value, this.idLevelAnggota);
          }, 1000)      
      }
    },
    methods: {
        getData(currentPage, pageSize, filter,idLevel) {
        let loader = this.$loading.show({
            container: false ? null : this.$refs.formContainer,
            canCancel: true,
            onCancel: this.onCancel
        });
        var vm = this;
        SertifikasiService.getSertifikasi(currentPage, pageSize, filter,idLevel)
            .then(response => {
            console.log(response)
            loader.hide();
            // comment console console.log(response.data.data.content);
            vm.items = response.data.content;
            vm.pagination.totalPages = response.data.totalPages;
            vm.currentPage = response.data.pageAble.pageNumber + 1;
            setTimeout(() => loader.hide(), 1000);
            })
            .catch(error => {
            // comment console console.log(error);
            });
        },  
        roleData() {
            var user = JSON.parse(localStorage.getItem('user'));
            var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
            this.role_status = data;
        },
        pageDisplay(e) {
          console.log(e.target.value)
        },
        pilihLevel(value) {
          this.idLevelAnggota = value.idLevelAnggota
          if(value.idLevelAnggota == 'default') {
            this.idLevelAnggota = ''
          } else {
            this.idLevelAnggota = value.idLevelAnggota
          }
          console.log(this.idLevelAnggota)
          setTimeout(() => {      
            this.getData(this.currentPage - 1, 10, this.search, this.idLevelAnggota);
          }, 1000)
        },
        exportDataSertifikasi() {
          console.log(this.idLevelAnggota)          
        },
        formatPrice(value) {
          let val = (value / 1).toFixed(2).replace(".", ",");
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        deleteData(item, index) {
        var vm = this;
        vm.formData = item;
        vm.$swal.fire({
            title: "Peringatan!",
            text: "Apakah anda yakin ingin menghapus data ini ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya",
            cancelButtonText: "Tidak",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            reverseButtons: true
          })
          .then(result => {
            if (result.value) {
              console.log('test')
              return false
              SertifikasiService.deleteSertifikasi(vm.formData)
                .then(response => {                
                  vm.alertDeleteSuccess();
                  vm.getData("0", this.pageSize, 'default','default');
                })
                .catch(error => {
                  vm.alertError(error.response.data.message);                
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              vm.$swal.fire(
                "Cancelled",
                "Your imaginary file is safe :)",
                "error"
              );
            }
          });
      },
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
